<template>

    <form @submit="submit" class="item-editor-form">
        <b-form-group v-if="!isFirstStop">
            <div class="w-50">
                <label for="drivingtime">{{ $t('routestop.driving_time') }}:</label> 
                <input type="text" class="form-control" v-model="item.ajoaika" placeholder="min">
            </div>
        </b-form-group>

        <stopSelect v-if="action == 'new'" v-model="item.tunnus" id="stop"/>

        <FormButtons
            @submit="submit" 
            :reset="false" 
            :remove="false" 
            :disableSubmit="loading" />

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
    
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import stopSelect from '@/components/Timetable/StopSelect'
import moment from 'moment';

export default {
    components: {
        FormButtons, stopSelect
    },
    props: {
        item: {
            required: true
        },
        action: { default: "new" },
        route: { default: null },
        isFirstStop: { default: false },
        defaultPassingTime: moment("00:00:00","HH:mm:ss")
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },    
    computed: {
        delModalTitle() {
            return this.$t("routestop.delete.title")
        },
        formatItem() {
            var newItem = this.item;
            if( this.isFirstStop ) {
                newItem.jarjestys = 0;
                newItem.reitti = this.route;
            }    
            if( newItem.firstStopPassingTime ) {
                delete newItem.firstStopPassingTime;
            }
            
            if( moment(newItem.ajoaika, "m", true).isValid() ) {
                newItem.ajoaika = moment(newItem.ajoaika, "m").format("HH:mm:ss");
            } else {
                newItem.ajoaika = this.defaultPassingTime;
            }

           return newItem; 
        }        
    },    
    watch: {
        item() {
            this.ok = this.error = this.loading = false;            
        } 
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();   

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('timetable/updateRoutestop' , this.formatItem).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    setTimeout(() => { this.$emit('refreshRoutestops', this.item.reitti); }, 1000);
                    this.loading = false;
                })
            }, 1000);
        },
        reset(event){
            event.preventDefault();
            this.item = {};              
        }
    }
}
</script>

